import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const TmetricSharedState = {
  tmetricClientName: null,
  tmetricClients: null,
  isTmetricEnabledForCurrentUser: false,
}

export const TmetricSharedActions = {
  getTmetricClients: async ({ commit }) => {
    return axiosRequest.
      get('/tmetric/clients').
      then(({ data }) => commit('setTmetricClients', data.data)).
      catch(handleError)
  },

  getTmetricClientName: async ({ commit, getters }) => {
    return axiosRequest.
      get('/tmetric/clients').
      then(({ data }) => {
        commit('setTmetricClientName', data.data.find(d => d.clientId === getters.tmetricSettings.tmetric_client_id)?.clientName)
      }).
      catch(handleError)
  },

  getTmetricEnabledForCurrentUser: async ({ commit }) => {
    return axiosRequest.
      get('/users/tmetric/enabled').
      then(({ data }) => commit('setTmetricEnabledForCurrentUser', data.enabled)).
      catch(handleError)
  },
}

export const TmetricSharedMutations = {
  setTmetricClientName: (state, value) => { state.tmetricClientName = value },
  setTmetricClients: (state, clients) => { state.tmetricClients = clients },
  setTmetricEnabledForCurrentUser: (state, value) => { state.isTmetricEnabledForCurrentUser = value },
}

export const TmetricSharedGetters = {
  isTmetricEnabledForCurrentUser: state => state.isTmetricEnabledForCurrentUser,
  tmetricClientName: (state, getters) => state.tmetricClients?.find(d => d.clientId === state.tmetricSettings.tmetric_client_id)?.clientName,
  tmetricClients: state => state.tmetricClients,
}
